'use client';

import { c as _c } from "react/compiler-runtime";
import { type Rule } from '@shared/all/domains/spaces';
import toast from '@shared/utils/helpers/toast';
import { useState } from 'react';
import { client } from '../../utils/trpc';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
import Input from '../UI/Input';
type Props = {
  closeHandler: () => void;
  type: number | 'new';
  rule?: Rule;
  spaceSlug?: string;
  factiiiId?: number;
  addRule: (rule: Rule) => void;
  editRule: (rule: Rule) => void;
};
const EditRules = props => {
  const $ = _c(28);
  const [title, setTitle] = useState(props.rule?.title || "");
  const [description, setDescription] = useState(props.rule?.description || "");
  const [buttonLoading, setButtonLoading] = useState(false);
  const addRule = props.addRule;
  const editRule = props.editRule;
  let t0;
  if ($[0] !== addRule || $[1] !== description || $[2] !== editRule || $[3] !== props || $[4] !== title) {
    t0 = async () => {
      setButtonLoading(true);
      if (!title || !description) {
        return toast("Title or description cannot be empty", "", "error");
      }
      const isFactiii = Boolean(props.factiiiId);
      if (props.type === "new") {
        if (isFactiii && props.factiiiId) {
          const [, data] = await client.factiiis.updateRule.mutate({
            factiiiId: props.factiiiId,
            title,
            description
          });
          if (data) {
            addRule(data.rule);
          }
        } else {
          if (props.spaceSlug) {
            const [, data_0] = await client.spaces.updateRule.mutate({
              slug: props.spaceSlug,
              title,
              description,
              ruleId: 0
            });
            if (data_0) {
              addRule(data_0.rule);
            }
          }
        }
      } else {
        if (!props.rule) {
          return;
        }
        if (isFactiii && props.factiiiId) {
          const [, data_1] = await client.factiiis.updateRule.mutate({
            factiiiId: props.factiiiId,
            title,
            description,
            ruleId: props.rule.id
          });
          if (data_1) {
            editRule(data_1.rule);
          }
        } else {
          if (props.spaceSlug) {
            const [, data_2] = await client.spaces.updateRule.mutate({
              title,
              description,
              ruleId: props.rule.id,
              slug: props.spaceSlug
            });
            if (data_2) {
              editRule(data_2.rule);
            }
          }
        }
      }
      setButtonLoading(false);
      props.closeHandler();
    };
    $[0] = addRule;
    $[1] = description;
    $[2] = editRule;
    $[3] = props;
    $[4] = title;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const saveHandler = t0;
  const t1 = `${props.type === "new" ? "New" : "Modify"} Rule`;
  let t2;
  if ($[6] !== t1) {
    t2 = <ModalHeader><h2>{t1}</h2></ModalHeader>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== title) {
    t3 = <Input type="text" label="Title" value={title} onChange={setTitle} />;
    $[8] = title;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== description) {
    t4 = <Input type="textarea" label="Description" value={description} onChange={setDescription} />;
    $[10] = description;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <ModalContent>{t3}{t4}</ModalContent>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props.closeHandler) {
    t6 = <Button text="Cancel" variant="SECONDARY" borderTransparent={false} onClick={props.closeHandler} />;
    $[15] = props.closeHandler;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== buttonLoading || $[18] !== saveHandler) {
    t7 = <Button text="Save" onClick={saveHandler} disabled={buttonLoading} loading={buttonLoading} />;
    $[17] = buttonLoading;
    $[18] = saveHandler;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <ModalFooter>{t6}{t7}</ModalFooter>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== props.closeHandler || $[24] !== t2 || $[25] !== t5 || $[26] !== t8) {
    t9 = <Modal closeHandler={props.closeHandler}>{t2}{t5}{t8}</Modal>;
    $[23] = props.closeHandler;
    $[24] = t2;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
export default EditRules;